import { useDataValue } from 'Simple/Data.js'
import { useMutation } from 'Data/Api.js'
import mutation from './mutation.graphql.js'
export function useOnChange(props) {
  let id = useDataValue({
    context: 'email',
    viewPath: props.viewPath,
    path: 'id',
  })
  let location_id = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'current_location._id',
  })
  let [, executeMutation] = useMutation(mutation)

  return async function onChange(value) {
    if (!value) return
    await executeMutation({
      location_id,
      sender_id: id,
    })
  }
}
